import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';
import { DelegationsService } from '../../common/_services/delegations.service';
import { Delegation } from '../../common/_types/delegation';

@Component({
    selector: 'app-delegations-detail',
    templateUrl: './delegations-detail.component.html',
    styleUrls: ['./delegations-detail.component.scss'],
    standalone: false
})
export class DelegationsDetailComponent {
  public delegationFormGroup!: RxFormGroup;

  public delegation: Delegation = new Delegation();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private delegationService: DelegationsService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
  ) {

    this.delegationFormGroup = this.formBuilder.formGroup<Delegation>(this.delegation) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalle de delegación");
    this.topbarService.addBreadcrumb("Delegaciones", "/delegations");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadDelegation(id);
    } 

    this.allowWrite = this.loginService.hasPermission("DELEGATIONS.WRITE");
    this.allowDelete = this.loginService.hasPermission("DELEGATIONS.DELETE");

  }

  async loadDelegation(id: string) {
    this.delegation = await firstValueFrom(this.delegationService.get(id));
    this.delegationFormGroup.patchValue(this.delegation);
  }


  async save() {
    let valid = this.formValidationService.validateForm(this.delegationFormGroup);
    if (valid) {
      this.delegation = Object.assign(this.delegation, this.delegationFormGroup.value);
      
      let delegation = await firstValueFrom(this.delegationService.save(this.delegation));
      this.messageService.add({ closable: true, severity: 'success', summary: "Delegación guardada correctamente." });
      this.router.navigate(['delegations']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la delegación?",
      header: "Eliminar delegación",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.delegationService.delete(this.delegation.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Delegación eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['delegations']);
  }
}
